const defaultHeaders = [
    {
        name: 'lote',
        text: 'Lote',
        order: false,
        position: 0
    },
    {
        name: 'status',
        text: 'Status',
        order: false,
        position: 1
    },
    {
        name: 'processado',
        text: 'Processado em:',
        order: false,
        position: 3
    }
]

const contract = {
    header: defaultHeaders.concat([
        {
            name: 'contratos',
            text: 'Contratos',
            position: 4,
            order: false
        },
        {
            name: 'processados',
            text: 'Processados',
            position: 5,
            order: false
        },
        {
            name: 'dataUpload',
            text: 'Data Upload',
            order: false,
            position: 2
        }
    ])
}

const images = {
    header: defaultHeaders.concat([
        {
            name: 'contratos',
            text: 'Imagens',
            position: 4,
            order: false
        },
        {
            name: 'processados',
            text: 'Processados',
            position: 5,
            order: false
        },
        {
            name: 'dataCriacao',
            text: 'Data Criação',
            order: false,
            position: 2
        }
    ])
}

export const variablesByType = (type: 'contract' | 'image') => {
    const selectedType = type === 'contract' ? contract : images

    return {
        header: selectedType.header
    }
}
